import ReactGA from "react-ga4";
import hotjar from "@hotjar/browser";
import Clarity from "@microsoft/clarity";

export function useAnalytics() {
  const trackGA4Event = (eventName: string, params?: Record<string, any>) => {
    try {
      ReactGA.event(eventName, params || {});
    } catch (err) {
      // console.warn("GA4 tracking failed:", err);
    }
  };

  const trackHotjarEvent = (eventName: string) => {
    try {
      hotjar.event(eventName);
    } catch (err) {
      // console.warn("Hotjar event failed:", err);
    }
  };

  const trackClarityEvent = (eventName: string) => {
    try {
      // Clarity uses a single string for events
      Clarity.event(`${eventName}`);
    } catch (err) {
      // console.warn("Clarity event failed:", err);
    }
  };

  const trackAllEvents = (eventName: string, params?: Record<string, any>) => {
    trackGA4Event(eventName, params);
    trackClarityEvent(eventName);
  };

  const trackFeatureUsage = (feature: string, params?: Record<string, any>) => {
    trackGA4Event(`feature_${feature}`, { feature_name: feature, ...params });
    trackClarityEvent(`feature_${feature}`);
  };

  return {
    trackGA4Event,
    trackHotjarEvent,
    trackClarityEvent,
    trackAllEvents,
    trackFeatureUsage
  };
}
